import styled from 'styled-components'
import { darken, colors, radiuses } from 'styles'

export const StyledInternalBanner = styled.div`
  padding: 4rem 0;

  p {
    margin: 0 0 2.5rem;
    line-height: 1.4;
    font-size: 1.8rem;
    font-weight: 300;
    color: ${colors.mainInverted};
  }
  strong {
    color: ${colors.highlight};
    font-weight: 600;
  }
  a {
    display: block;
    padding: 1rem;
    border: none;
    font-size: 1.6rem;
    border-radius: ${radiuses.large};
    background-color: ${colors.highlight};
    text-align: center;
    font-weight: 700;
    color: ${colors.mainInverted};
    text-transform: uppercase;
    text-decoration: none;
    box-shadow: 0px 6px 16px ${p => darken(0.2, p.theme.colors.main)};
  }
`

export const StyledExternalBanner = styled.div`
  display: flex;
  width: 100%;
  min-height: 25rem;
  color: ${colors.textMain};
  border-radius: ${radiuses.large};
  overflow: hidden;
`
